import {
  CourseViewer,
  ModuleProgress,
  ModuleProgressStatus,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Resolves the module a "Continue where you left off" / "Continue" action
// should navigate to: the viewer's resume pointer, falling back to the
// enrollment's pointer, then the first module.
export function resolveResumeModuleUuid(
  viewer: Pick<
    CourseViewer,
    "lastAccessedModuleUuid" | "enrollment" | "modules"
  >,
): string | undefined {
  return (
    viewer.lastAccessedModuleUuid ??
    viewer.enrollment?.lastAccessedModuleUuid ??
    viewer.modules[0]?.uuid
  );
}

// Builds a map of moduleUuid -> progress status from the per-module progress
// array returned by the viewer endpoint. Modules with no progress row default
// to "not_started".
export function buildModuleStatusMap(
  moduleProgress: ModuleProgress[],
): Record<string, ModuleProgressStatus> {
  const map: Record<string, ModuleProgressStatus> = {};
  for (const p of moduleProgress) {
    map[p.moduleUuid] = p.status;
  }
  return map;
}

export function isModuleComplete(
  statusMap: Record<string, ModuleProgressStatus>,
  moduleUuid: string,
): boolean {
  return statusMap[moduleUuid] === "completed";
}

// Rounds a decimal percentage string ("66.67") to a whole number for display.
export function formatProgressPercent(progressPercentage: string): number {
  const value = Number.parseFloat(progressPercentage);
  return Number.isFinite(value) ? Math.round(value) : 0;
}

export function countCompleted(
  statusMap: Record<string, ModuleProgressStatus>,
): number {
  return Object.values(statusMap).filter((s) => s === "completed").length;
}
